import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'


import {
  SAVE_PARAMS_SUPPLY_REQUEST,
  SAVE_PARAMS_SUPPLY_REQUEST_ERROR,
  SAVE_PARAMS_SUPPLY_REQUEST_SUCCESS,
  FETCH_PARAMS_SUPPLY_REQUEST,
  FETCH_PARAMS_SUPPLY_REQUEST_SUCCESS,
  FETCH_PARAMS_SUPPLY_REQUEST_ERROR,
  FETCH_SECTIONS_DEFAULT
} from 'actionTypes'

export const fetchSections = (token, params) => (dispatch) => {
 
  const supplyParams = {cdBranch: params.gamaRegionsBranchsParams[0].branchRegion}
  dispatch(fetchSectionsRequest())
  return new Api(token, dispatch)
    .get(`${API_URL.FIND_PARAMS_SUPPLY}`, supplyParams)
    .then(dispatch(showSpinner()))
    .then(async (response) => {
      dispatch(fetchSectionsSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchSectionsError(error))
      dispatch(hideSpinner())
    })
}

export const resetParamsNexp = () => (dispatch) => {
  dispatch(fetchSectionsDefault())
}

export const fetchSectionsDefault = () => ({
  type: FETCH_SECTIONS_DEFAULT
})

export const fetchSectionsRequest = () => ({
  type: FETCH_PARAMS_SUPPLY_REQUEST,
})


export const fetchSectionsSuccess = (data) => ({
  type: FETCH_PARAMS_SUPPLY_REQUEST_SUCCESS,
  payload: data,
})

export const fetchSectionsError = (error) => ({
  type: FETCH_PARAMS_SUPPLY_REQUEST_ERROR,
  payload: error,
})

export const updateSupplyParams = (token, args, callBack) => (dispatch) => {
  dispatch(updateSupplyParamsRequest())

  return new Api(token, dispatch)
    .post(API_URL.SAVE_PARAMS_SUPPLY, args)
    .then(dispatch(showSpinner()))
    .then((response) => {
      /* istanbul ignore else */
      if (callBack) {
        callBack()
      }
      dispatch(updateSupplyParamsSuccess(response.data))
      dispatch(hideSpinner())

      return response
    })
    .catch((error) => {
      dispatch(updateSupplyParamsError(error))
      dispatch(hideSpinner())

      return error
    })
}


export const updateSupplyParamsRequest = () => ({
  type: SAVE_PARAMS_SUPPLY_REQUEST
})

export const updateSupplyParamsSuccess = (data) => ({
  type: SAVE_PARAMS_SUPPLY_REQUEST_SUCCESS,
  payload: data,
})

export const updateSupplyParamsError = (error) => ({
  type: SAVE_PARAMS_SUPPLY_REQUEST_ERROR,
  payload: { error },
})
